export const PUSH_ATTRIBUTE_VALUES_INTO_CACHE = 'PUSH_ATTRIBUTE_VALUES_INTO_CACHE' as 'PUSH_ATTRIBUTE_VALUES_INTO_CACHE'
export const RESET_ATTRIBUTE_VALUES_CACHE = 'RESET_ATTRIBUTE_VALUES_CACHE' as 'RESET_ATTRIBUTE_VALUES_CACHE'